import produce from 'immer';

import { createReducer, getErrorStatus, getInitialStatus, getPendingStatus } from '../utils';

import {
  BUILD_WATCHLIST_ADD,
  BUILD_WATCHLIST_REMOVE,
  FETCH_ALL_BUILDS,
  FETCH_ALL_COUNTS,
  FETCH_ONE_BUILD,
} from './actions';

const initialState = {
  watchedBuilds: [],
  tasks: {},
  builds: {},
  status: getInitialStatus(),
  counts: {
    status: getInitialStatus(),
    count: 0,
  },
};

export default createReducer(initialState, {
  [BUILD_WATCHLIST_ADD]: (state, action) => produce(state, draftState => {
    if (!state.watchedBuilds.includes(action.payload)) {
      draftState.watchedBuilds.push(action.payload);
    }
  }),
  [BUILD_WATCHLIST_REMOVE]: (state, action) => produce(state, draftState => {
    draftState.watchedBuilds = draftState.watchedBuilds.filter(buildId => buildId !== action.payload);
  }),
  [`${FETCH_ONE_BUILD}_FULFILLED`]: (state, action) => produce(state, draftState => {
    draftState.status = getInitialStatus();
    draftState.builds[action.meta.id] = action.payload.data;
  }),
  [`${FETCH_ALL_BUILDS}_PENDING`]: (state) => produce(state, draftState => {
    draftState.status = getPendingStatus();
  }),
  [`${FETCH_ALL_BUILDS}_FULFILLED`]: (state, action) => produce(state, draftState => {
    draftState.status = getInitialStatus();
    draftState.builds = {};
    action.payload.data.forEach((build) => {
      if (build?.id) {
        draftState.builds[build.id] = build;
      }
    });
  }),
  [`${FETCH_ALL_BUILDS}_REJECTED`]: (state, action) => produce(state, draftState => {
    draftState.status = getErrorStatus(action.payload);
  }),
  [`${FETCH_ALL_COUNTS}_PENDING`]: (state) => produce(state, draftState => {
    draftState.counts.status = getPendingStatus();
  }),
  [`${FETCH_ALL_COUNTS}_FULFILLED`]: (state, action) => produce(state, draftState => {
    draftState.counts.status = getInitialStatus();
    draftState.counts.count = action.payload.data;
  }),
  [`${FETCH_ALL_COUNTS}_REJECTED`]: (state, action) => produce(state, draftState => {
    draftState.counts.status = getErrorStatus(action.payload);
  }),
});
